import { PremiseTypeAlias } from '@/api/models/requests/lib/requests.types'

export type SignByCodeInArgs = {
  phone_number?: string
  email?: string
  smsCode: string
}

export type SignInResponse = {
  access_token: string
  expires_in: number
  refresh_token: string
  refresh_expires_in: number
}

export const enum ProjectSource {
  SC = 'SC',
  BU = 'BU'
}

export const enum PersonalAccountType {
  Owner = 'owner',
  Trusted = 'trusted'
}

export type PersonalAccount = {
  id: string
  name: string
  number: string
  premises: Premise[]
  permissionMask: number
  type: PersonalAccountType
}

export type ProjectResponse = {
  id: string
  name: string
  src: ProjectSource
  personalAccounts: PersonalAccount[]
}

export type UserInfoResponse = {
  sub: string
  projects: ProjectResponse[]
  email_verified: boolean
  preferred_username: string
  title: string
  middle_name: string
  given_name: string
  isTechnicalAccount: boolean
  name: string
  isMobileNumberConfirmed: boolean
  isProcessingPdAccepted: boolean
  middleName: string
  isLegalEntity: boolean
  mobile_number: string
  family_name: string
  email: string
  guid1c: string
}

export type Premise = {
  id: string
  name: string
  typeAlias: PremiseTypeAlias
  number: string
}

export type Project = {
  bc_guid: string
  bc_name: string
  src: ProjectSource
  premises: Premise[]
  allPremises: Premise[]
  personalAccounts: PersonalAccount[]
}

export type UserInfo = {
  name: string
  title: string
  email: string
  phone_number: string
  guid: string
  isLegalEntity: boolean
  projects: Project[]
}

export enum GrantTypeEnum {
  PASSWORD = 'password',
  REFRESH_TOKEN = 'refresh_token'
}
